// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
//   Button,
//   Box,
//   Typography,
//   Grid,
// } from "@mui/material";
// import { Close as CloseIcon } from "@mui/icons-material";
// import { Formik, Form } from "formik";

// import { FaPlus } from "react-icons/fa6";
// import { MdPayment } from "react-icons/md";

// import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
// import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"; // Import external CSS
// import { MdCancel } from "react-icons/md";
// import * as Yup from "yup";
// import { FiUpload } from "react-icons/fi";
// import FileUploadComponent from "../../../Components/FileUploadComponent/FileUploadComponent";
// import ActiveInactiveRadio from "../../../Components/ActiveInactiveRadio/ActiveInactiveRadio";
// import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
// import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
// import CustomDropdownDocumentType from "../../../Components/CustomDropDown/CustomDropdownDocumentType";
// import FileUploadForCreateUser from "../../../Components/FileUploadComponent/FileUploadForCreateUser";
// import { useDispatch, useSelector } from "react-redux";
// import actions from "../../../ReduxStore/actions/index";
// import { toast, ToastContainer } from "react-toastify";

// const AllUserListCreateModal = ({
//   open,
//   onClose,
//   setSubmittedValues,
//   submittedValues,
//   modalHeadingName,
// }) => {
//   // const [uploadedFile, setUploadedFile] = useState(null);
//   const [uploadedFiles, setUploadedFiles] = useState([]);
//   const [selectedDocumentType, setSelectedDocumentType] = React.useState("");

//   const dispatch = useDispatch();

//   const { multiUserCreation } = useSelector(
//     (state) => state?.multiUserCreation
//   );
//   const token = localStorage.getItem('AuthToken');

//   const UserCreateSubmit = async (values, { resetForm }) => {
//     console.log(values, "vaUserCreateSubmitUserCreateSubmitlues");

//     console.log(token, "tokennnn")
//     const data1 = {
//       data: values,
//       method: "post",
//       apiName: `registerAuthUser`,
//       headers: {
//         Authorization: `Bearer ${token}`,  // Pass auth token in headers
//         "Content-Type": "application/json",
//       },
//     };
//     const multiUserCreationResponse = await dispatch(
//       actions.MULTIUSERCREATION(data1)
//     );

//     if (
//       multiUserCreationResponse.payload.message ===
//       "User registered successfully."
//     ) {
//       toast.success(`${multiUserCreationResponse.payload.message}`);

//       resetForm();

//       setTimeout(() => onClose(), 1500);
//     } else {
//       toast.error(`${multiUserCreationResponse.payload.message}`);
//     }
//   };

//   const { createRoleWithPermissions } = useSelector(
//     (state) => state?.createRoleWithPermissions
//   );

//   const { getAllRoles } = useSelector(
//     (state) => state?.getAllRoles
//   );


//   useEffect(() => {
//     const fetchData = async () => {
//       const data1 = { data: {}, method: "get", apiName: `getAllRoles` };
//       await dispatch(actions.GETALLROLES(data1));
//     };
//     fetchData();
//   }, [dispatch, createRoleWithPermissions]);



//   const [getAllRolesData, setGetAllRolesData] = useState([]);

//   useEffect(() => {
//     const tempArr = [];
//     getAllRoles?.data?.map((data, index) => {
//       return tempArr.push({
//         label: data?.roleName,
//         value: data?.roleName
//       });
//     });
//     setGetAllRolesData(tempArr);
//   }, [dispatch, getAllRoles, createRoleWithPermissions]);

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="md"
//       className="custom-dialog"
//       sx={{
//         // maxWidth: "700px",
//         // margin: "auto",
//         "& .MuiPaper-root": {
//           borderRadius: "14px", // Target the Paper component
//         },
//       }}
//     >
//       <ToastContainer
//         position="top-right"
//         autoClose={1500}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="dark"
//       />

//       <Box sx={{ position: "relative" }}>
//         <Box className="dialog-heading">
//           <IconButton
//             aria-label="Close"
//             onClick={onClose}
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               color: "text.secondary",
//             }}
//           >
//             <MdCancel />
//           </IconButton>
//           <DialogTitle className="custom-dialog-title">
//             <Box>
//               <Typography className="custom-title-text" color="white">
//                 {modalHeadingName}
//               </Typography>
//             </Box>
//           </DialogTitle>
//         </Box>

//         <Formik
//           initialValues={{
//             name: "",
//             roleName: "",
//             emiratesid: "",
//             email: "",
//             phone: "",
//             password: "",
//             confirm_password: "",
//           }}
//           validationSchema={Yup.object({
//             name: Yup.string().required("Name is required"),
//             roleName: Yup.string().required("User Role is required"),
//             email: Yup.string()
//               .email("Invalid email")
//               .required("Email is required"),
//             phone: Yup.string()
//               .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
//               .required("Phone number is required"),
//             password: Yup.string()
//               .min(5, "Password must be at least 5 characters")
//               .required("Password is required"),
//             confirm_password: Yup.string()
//               .min(5, "Password must be at least 5 characters")
//               .required("Password is required"),
//           })}
//           onSubmit={UserCreateSubmit}
//         >
//           {({ handleSubmit, setFieldValue, resetForm, values }) => (
//             <Form onSubmit={handleSubmit}>
//               <DialogContent dividers>
//                 <Grid container spacing={2}>
//                   {/* Title and Subtitle on the left, Content on the right */}
//                   <Grid item xs={12} md={12}>
//                     <Grid container spacing={2}>
//                       <Grid item xs={12} md={4}>
//                         <CustomInputLogin
//                           label="Name"
//                           name="name"
//                           inputType="text"
//                           custPlaceholder="Enter Name"
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <CustomInputLogin
//                           label="Email"
//                           name="email"
//                           inputType="email"
//                           custPlaceholder="Enter Email"
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <CustomInputLogin
//                           label="Mobile Number"
//                           name="phone"
//                           inputType="number"
//                           custPlaceholder="Enter Mobile Number"
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <CustoDropDownRegister
//                           important={true}
//                           name="roleName"
//                           label="User Role"
//                           custPlaceholder="select a Role"
//                           options={getAllRolesData}
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <CustomInputLogin
//                           label="Password"
//                           name="password"
//                           inputType="password"
//                           custPlaceholder="Enter Password"
//                         />
//                       </Grid>
//                       <Grid item xs={12} md={4}>
//                         <CustomInputLogin
//                           label="Confirm Password"
//                           name="confirm_password"
//                           inputType="password"
//                           custPlaceholder="Enter Confirm Password"
//                         />
//                       </Grid>
//                       {/* <Grid item xs={12} md={4}>

//                                                 <ActiveInactiveRadio name="status"
//                                                     value={values.status} // Ensure this is correctly passed from Formik
//                                                     onChange={(value) => setFieldValue('status', value)}// Update the Formik state when the radio button changes
//                                                 />
//                                             </Grid> */}
//                     </Grid>
//                   </Grid>
//                 </Grid>

//                 {/* Action Buttons */}
//                 {/* <DialogActions> */}
//                 <Grid sx={{ display: "flex", justifyContent: "end", mt: 4 }}>
//                   <Grid>
//                     <Button
//                       onClick={() => {
//                         resetForm();
//                         setUploadedFiles(null);
//                       }}
//                       variant="text"
//                       // className="custom-clear-button"
//                       sx={{
//                         // backgroundColor: "#C38F51",
//                         textTransform: "none",
//                         color: "white",
//                         fontSize: "16px",
//                         mr: "10px",
//                         // padding: "0px 40px",
//                         padding: { xs: "0px 20px", md: "0px 40px" },

//                         minHeight: "40px",
//                         borderRadius: "23px",
//                         background: "white",
//                         boxShadow: "none",
//                         color: "black",
//                         border: "1px solid black",
//                         "&:hover": {
//                           backgroundColor: "#3B4056",
//                           color: "white",
//                         },
//                       }}
//                     >
//                       Cancel
//                     </Button>
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       // className="custom-ok-button"
//                       sx={{
//                         // backgroundColor: "#C38F51",
//                         textTransform: "none",
//                         color: "white",
//                         fontSize: "16px",
//                         boxShadow: "none",

//                         // padding: "0px 40px",
//                         padding: { xs: "0px 20px", md: "0px 40px" },

//                         minHeight: "40px",
//                         borderRadius: "23px",
//                         background: "#C38F51 0% 0% no-repeat padding-box",
//                         "&:hover": {
//                           backgroundColor: "#3B4056",
//                           boxShadow: "none",
//                         },
//                       }}
//                     >
//                       Submit
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </DialogContent>

//               {/* </DialogActions> */}
//             </Form>
//           )}
//         </Formik>
//       </Box>
//     </Dialog>
//   );
// };

// export default AllUserListCreateModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Box,
  Typography,
  Grid,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { Formik, Form } from "formik";

import { FaPlus } from "react-icons/fa6";
import { MdPayment } from "react-icons/md";

import CustomInputLogin from "../../../Components/CustomInputLogin/CustomInputLogin";
import "../../ContentManagement/Home/Modal/BannerinputGetModal.css"; // Import external CSS
import { MdCancel } from "react-icons/md";
import * as Yup from "yup";
import { FiUpload } from "react-icons/fi";
import FileUploadComponent from "../../../Components/FileUploadComponent/FileUploadComponent";
import ActiveInactiveRadio from "../../../Components/ActiveInactiveRadio/ActiveInactiveRadio";
import CustomDateInput from "../../../Components/CustomDate/CustomDateInput";
import CustoDropDownRegister from "../../../Components/CustomDropDown/CustoDropDownRegister";
import CustomDropdownDocumentType from "../../../Components/CustomDropDown/CustomDropdownDocumentType";
import FileUploadForCreateUser from "../../../Components/FileUploadComponent/FileUploadForCreateUser";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../ReduxStore/actions/index";
// import { toast, ToastContainer } from "react-toastify";
import { toast, ToastContainer } from "react-toastify";

import { clearCustomerId } from "../../../ReduxStore/Slices/Operator/customerSlice";
import { clearTableGetId } from "../../../ReduxStore/Slices/TableId/TableIdGetSlice";

const AllUserListCreateModal = ({
  open,
  onClose,
  setSubmittedValues,
  submittedValues,
  modalHeadingName,
}) => {
  // const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = React.useState("");

  const dispatch = useDispatch();


  const [formValues, setFormValues] = useState({
    name: "",
    roleName: "",
    emiratesid: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  });


  console.log(formValues, "formValuessssss")
  const { multiUserCreation } = useSelector(
    (state) => state?.multiUserCreation
  );

  const { updateAuthUser } = useSelector(
    (state) => state?.updateAuthUser
  );


  const token = sessionStorage.getItem('token');

  const UserCreateSubmit = async (values, { resetForm }) => {
    console.log(values, "vaUserCreateSubmitUserCreateSubmitlues");

    console.log(token, "tokennnn")

    if (!customerId) {
      const data1 = {
        data: values,
        method: "post",
        apiName: `registerAuthUser`,
        // headers: {
        //   Authorization: `Bearer ${token}`,  // Pass auth token in headers
        //   "Content-Type": "application/json",
        // },
      };
      const multiUserCreationResponse = await dispatch(
        actions.MULTIUSERCREATION(data1)
      );

      if (
        multiUserCreationResponse.payload.message ===
        "User registered successfully."
      ) {
        toast.success(`${multiUserCreationResponse.payload.message}`)
        resetForm();

        setTimeout(() => onClose(), 1500);
      } else {
        // toast.error(`${multiUserCreationResponse.payload.message}`);
        toast.error(`${multiUserCreationResponse.payload.message}`)
      }
    }

    if (customerId) {

      console.log(customerId, "ediiiiiiiiiiit");

      const data1 = {
        data: values,
        method: "put",
        apiName: `updateAuthUser/${customerId}`,
        headers: {
          Authorization: `Bearer ${token}`,  // Pass auth token in headers
          "Content-Type": "application/json",
        },
      };
      const updateAuthUserResponse = await dispatch(
        actions.UPDATEAUTHUSER(data1)
      );

      if (
        updateAuthUserResponse.payload.message ===
        "User updated successfully."
      ) {

        toast.success(`${updateAuthUserResponse.payload.message}`);


        resetForm();

        setTimeout(() => onClose(), 2500);
        dispatch(clearCustomerId(null))
        dispatch(clearTableGetId(null))
      } else {
        toast.error(`${updateAuthUserResponse.payload.message}`);
      }

    }
  };

  const { createRoleWithPermissions } = useSelector(
    (state) => state?.createRoleWithPermissions
  );

  const { getAllRoles } = useSelector(
    (state) => state?.getAllRoles
  );


  useEffect(() => {
    // if (!open) return;

    const fetchData = async () => {
      const data1 = { data: {}, method: "get", apiName: `getAllRoles` };
      await dispatch(actions.GETALLROLES(data1));
    };
    fetchData();
  }, [dispatch, createRoleWithPermissions]);



  const [getAllRolesData, setGetAllRolesData] = useState([]);


  useEffect(() => {
    const tempArr = [];
    getAllRoles?.data?.map((data, index) => {
      return tempArr.push({
        label: data?.roleName,
        value: data?.roleName
      });
    });
    setGetAllRolesData(tempArr);
  }, [dispatch, getAllRoles, createRoleWithPermissions]);



  // edit-----------------------------------------------

  const { getAuthUserById } = useSelector((state) => state?.getAuthUserById);
  const customerId = useSelector((state) => state.customer.customerId);

  console.log(customerId, "hindkdmkfmdkdmdkfmslfmkldmfa");


  console.log(getAuthUserById?.data, "getAuthUserByIdgetAuthUserById");

  useEffect(() => {
    if (!open) return;
    const fetchData = async () => {
      if (customerId) {
        const data1 = { data: {}, method: "get", apiName: `getAuthUserById/${customerId}` };
        const getAuthUserByIdResponese = await dispatch(actions.GETAUTHUSERBYID(data1));

        console.log(getAuthUserByIdResponese?.payload?.data, "getAuthUserByIdResponese");


        setFormValues({
          name: getAuthUserByIdResponese?.payload?.data?.name,
          roleName: getAuthUserByIdResponese?.payload?.data?.role?.roleName,
          emiratesid: "",
          email: getAuthUserByIdResponese?.payload?.data?.email,
          phone: getAuthUserByIdResponese?.payload?.data?.phone,
          password: getAuthUserByIdResponese?.payload?.data?.password,
          confirm_password: getAuthUserByIdResponese?.payload?.data?.password,
        })

      } else {
        setFormValues({
          name: "",
          roleName: "",
          emiratesid: "",
          email: "",
          phone: "",
          password: "",
          confirm_password: "",
        })

      }
    };
    fetchData();
  }, [dispatch, customerId]);





  return (
    <Dialog
      open={open}
      // onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        // maxWidth: "700px",
        // margin: "auto",
        "& .MuiPaper-root": {
          borderRadius: "14px", // Target the Paper component
        },
      }}
    >

      <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      <Box sx={{ position: "relative" }}>
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={() => {
              onClose()
              dispatch(clearCustomerId(null))
              dispatch(clearTableGetId(null))


            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Box>
              <Typography className="custom-title-text" color="white">
                {customerId ? "Update User Details" : modalHeadingName}
              </Typography>
            </Box>
          </DialogTitle>
        </Box>

        <Formik
          enableReinitialize
          initialValues={formValues}
          validationSchema={Yup.object({
            name: Yup.string().required("Name is required"),
            roleName: Yup.string().required("User Role is required"),
            email: Yup.string()
              .email("Invalid email")
              .required("Email is required"),
            phone: Yup.string()
              .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
              .required("Phone number is required"),
            ...(customerId
              ? {} // If customerId exists, exclude password validation
              : {
                password: Yup.string()
                  .min(5, "Password must be at least 5 characters")
                  .required("Password is required"),
                confirm_password: Yup.string()
                  .min(5, "Password must be at least 5 characters")
                  .required("Password is required"),
              }),
          })}
          onSubmit={UserCreateSubmit}
        >
          {({ handleSubmit, setFieldValue, resetForm, values }) => (
            <Form onSubmit={handleSubmit}>
              <DialogContent dividers>
                <Grid container spacing={2}>
                  {/* Title and Subtitle on the left, Content on the right */}
                  <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Name"
                          name="name"
                          inputType="text"
                          custPlaceholder="Enter Name"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Email"
                          name="email"
                          inputType="email"
                          custPlaceholder="Enter Email"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label="Mobile Number"
                          name="phone"
                          inputType="number"
                          custPlaceholder="Enter Mobile Number"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustoDropDownRegister
                          important={true}
                          name="roleName"
                          label="User Role"
                          custPlaceholder="Select  Role"
                          options={getAllRolesData}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <CustomInputLogin
                          label={customerId ? "New password" : "Password"}
                          name="password"
                          inputType="password"
                          custPlaceholder="Enter Password"
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        {!customerId && <CustomInputLogin
                          label="Confirm Password"
                          name="confirm_password"
                          inputType="password"
                          custPlaceholder="Enter Confirm Password"
                        />}
                      </Grid>
                      {/* <Grid item xs={12} md={4}>

                                                <ActiveInactiveRadio name="status"
                                                    value={values.status} // Ensure this is correctly passed from Formik
                                                    onChange={(value) => setFieldValue('status', value)}// Update the Formik state when the radio button changes
                                                />
                                            </Grid> */}
                    </Grid>
                  </Grid>
                </Grid>

                {/* Action Buttons */}
                {/* <DialogActions> */}
                <Grid sx={{ display: "flex", justifyContent: "end", mt: 4 }}>
                  <Grid>
                    <Button
                      onClick={() => {
                        resetForm();
                        setUploadedFiles(null);
                        onClose()
                        dispatch(clearCustomerId(null))
                        dispatch(clearTableGetId(null))


                      }}
                      variant="text"
                      // className="custom-clear-button"
                      sx={{
                        // backgroundColor: "#C38F51",
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        mr: "10px",
                        // padding: "0px 40px",
                        padding: { xs: "0px 20px", md: "0px 40px" },

                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "white",
                        boxShadow: "none",
                        color: "black",
                        border: "1px solid black",
                        "&:hover": {
                          backgroundColor: "#3B4056",
                          color: "white",
                        },
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      // className="custom-ok-button"
                      sx={{
                        // backgroundColor: "#C38F51",
                        textTransform: "none",
                        color: "white",
                        fontSize: "16px",
                        boxShadow: "none",

                        // padding: "0px 40px",
                        padding: { xs: "0px 20px", md: "0px 40px" },

                        minHeight: "40px",
                        borderRadius: "23px",
                        background: "#C38F51 0% 0% no-repeat padding-box",
                        "&:hover": {
                          backgroundColor: "#3B4056",
                          boxShadow: "none",
                        },
                      }}
                    >
                      {customerId ? "Update" : "Submit"}
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>

              {/* </DialogActions> */}
            </Form>
          )}
        </Formik>

      </Box>
    </Dialog>
  );
};

export default AllUserListCreateModal;
